export const FOLDER_NOT_FOUND_TOAST_TITLE = 'Esta pasta não existe mais.';

export const MODULE_NOT_FOUND_TOAST_TITLE = 'Este módulo não existe mais.';

export const CONTAINER_CONTENT_ERROR_MESSAGE = 'Não foi possível carregar o conteúdo.';
